
import { Observable } from './druid/./druid/Observable';
import { delay } from './druid/./druid/operator/delay';

Observable.prototype.delay = delay;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    delay: typeof delay;
  }
}